import * as React from 'react';
import { cn } from '@/lib/utils';

/* ─── Types ────────────────────────────────────────────────────────────────── */

interface SparklineChartProps extends React.SVGAttributes<SVGSVGElement> {
  data: number[];
  color?: string;
  height?: number;
}

/* ─── SparklineChart ───────────────────────────────────────────────────────── */

const BAR_WIDTH = 4;
const BAR_GAP = 2;
const BAR_RX = 1;

const SparklineChart = React.forwardRef<SVGSVGElement, SparklineChartProps>(
  ({ data, color, height = 32, className, ...props }, ref) => {
    const max = Math.max(...data, 1);
    const totalWidth = data.length * BAR_WIDTH + (data.length - 1) * BAR_GAP;

    return (
      <svg
        ref={ref}
        width={totalWidth}
        height={height}
        viewBox={`0 0 ${totalWidth} ${height}`}
        fill="none"
        className={cn(color ?? 'text-raios-accent', className)}
        {...props}
      >
        {data.map((value, i) => {
          const barHeight = Math.max(2, (value / max) * height);
          const x = i * (BAR_WIDTH + BAR_GAP);
          const y = height - barHeight;

          return (
            <rect
              key={i}
              x={x}
              y={y}
              width={BAR_WIDTH}
              height={barHeight}
              rx={BAR_RX}
              fill="currentColor"
            />
          );
        })}
      </svg>
    );
  }
);

SparklineChart.displayName = 'SparklineChart';

export { SparklineChart };
export type { SparklineChartProps };
